import React from 'react';
import type { V2Guard, V2Route } from '../units/types';
import { OwnLocation } from './OwnLocation';

const page = (load: () => Promise<{ default: React.ComponentType }>): V2Route['Component'] =>
  React.lazy(async () => {
    const { default: Page } = await load();
    return {
      default: () => React.createElement(OwnLocation, null, React.createElement(Page)),
    };
  });

/** 旧 /taap・/ad-dashboard と同じく組織の enable_ad_operations。Meta・Google・連携の画面は旧画面も絞っていない */
const guard: V2Guard = { kind: 'feature', feature: 'enable_ad_operations' };

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'taap', Component: page(() => import('./TaapPage')), guard },
  { path: 'taap/proposals', Component: page(() => import('./ProposalsPage')), guard },
  {
    path: 'taap/proposals/:proposalId',
    Component: page(() => import('./ProposalDetailPage')),
    guard,
  },
  { path: 'ad-dashboard/meta', Component: page(() => import('./MetaPage')) },
  {
    path: 'ad-dashboard/google',
    Component: page(() => import('./GooglePage')),
  },
  {
    path: 'ad-dashboard',
    Component: page(() => import('./AdDashboardRedirect')),
    guard,
  },
  {
    path: 'settings/media-connect',
    Component: page(() => import('./ConnectPage')),
  },
];

export default routes;
